import json from "../../json/usageExposer/dashboard/usageExposerGetAggregatedScans.json";

export default async () => JSON.parse(JSON.stringify(json));
